import {
    faAppleWhole,
    faBolt,
    faBrain,
    faDumbbell,
    faHeart,
    faPerson,
    faUserGroup,
    faCirclePulse,
    faCirclePlay,
    faHeartPulse
  } from "@fortawesome/free-solid-svg-icons";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import { useContext, useMemo } from "react";
  import { useNavigate } from "react-router-dom";
  
  import AuthContext from "../context/AuthProvider";
  
  function MembershipBenefits() {
    const { auth } = useContext(AuthContext);
    const navigate = useNavigate();
    const iconMap = useMemo(
      () => ({
        "apple-whole": faAppleWhole,
        heart: faHeart,
        dumbbell: faDumbbell,
        brain: faBrain,
        bolt: faBolt,
        "circle-play": faCirclePlay,
        "heart-pulse": faHeartPulse,
        "user-group": faUserGroup,
        person: faPerson,
      }),
      []
    );
    const features =
      auth?.user?.membership?.plan?.features ?? [];
  
    if (!features.length) {
      return null;
    }
  
    return (
      <>
        <div className="mb-2 p-2 mt-4">
          <h2 className="text-2xl font-semibold text-[#41264B]">
            Membership Benefits
          </h2>
  
          <p className="text-[#866393] mt-1">
            Included with your current membership.
          </p>
        </div>
  
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {features.map((feature) => (
            <div
              key={feature.path}
              className="bg-white rounded-xl p-4 shadow-md border-l-8 hover:shadow-lg transition"
              style={{
                borderLeftColor: feature.colour,
              }}
            >
              <div className="flex items-center gap-3 mb-2">
                <div
                  className="rounded-lg px-3.5 py-2"
                  style={{
                    backgroundColor: feature.colour,
                  }}
                >
                  <FontAwesomeIcon
                    icon={iconMap[feature.icon] ?? faBolt}
                    className="text-[#41264B]"
                  />
                </div>
  
                <h3 className="text-[#41264B] font-semibold text-lg">
                  {feature.title}
                </h3>
              </div>
  
              <p className="text-sm text-[#41264B] mb-4">
                {feature.description}
              </p>
  
              {/* <button
                onClick={() => navigate(feature.path)}
                className="w-full border border-[#B4A6BA] text-[#866393] rounded-lg py-1 hover:bg-violet-50 transition text-sm"
              >
                View Service
              </button> */}
            </div>
          ))}
        </div>
      </>
    );
  }
  
  export default MembershipBenefits;